import { mapActions, mapState, mapMutations } from 'vuex'
import { REMOVE_DOCKET, ADD_LOAD } from 'vx/mutations'
import { alert } from 'utils'

export default {
  computed: mapState('load', ['load']),

  methods: {
    ...mapMutations('load', [ADD_LOAD]),
    ...mapActions('weighbridge/docket', ['deleteDocket']),
    ...mapActions('load', ['getLoad']),

    /**
     * Handle changes to the selected file.
     *
     * @param object files
     *
     * @return void
     */
    handleFileSelection ({ target: { files } }) {
      if (files.length === 0) {
        this.file = null

        return
      }

      this.file = files.item(0)
    },

    /**
     * Handle deleting a docket.
     *
     * @return Promise
     */
    handleDeleteDocket () {
      return new Promise((resolve, reject) => {
        // If we do not have an ID then we are working with a temporary docket that can easily
        // just be popped off of the state. So we'll do that and resolve...
        if (this.docket.id === null) {
          setTimeout(() => {
            this[REMOVE_DOCKET](this.identifiers)

            resolve()
          }, 500)

        // Otherwise we're dealing with an existing docket that IS actually saved, so we'll need
        // to fire off an API request to delete the docket and then pop it off the state.
        } else {
          return alert.delete({ text: 'Are you sure you want to delete this docket?' }).then(() => {
            return this.deleteDocket(this.docket.id).then(() => {
              this[REMOVE_DOCKET](this.identifiers)

              return this.updateLoadState().then(resolve)
            })
          }).catch(reject)
        }
      })
    },

    /**
     * Update the load state by fetching the load again.
     *
     * This replaces the load within the array of loads and pushes all the changes
     * where they need to go.
     *
     * @return Promise
     */
    updateLoadState () {
      return this.getLoad(this.load.id).then(() => {
        this[ADD_LOAD](this.load)

        this.$bus.$emit('loadStateUpdated', this.load)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/weighbridge/docket-actions-helpers.js